import React, { useEffect, useState } from "react";

const ListPortfolio = (props) => {
	const [styleContents, setStyleContents] = useState({});
	const [active, setActive] = useState(false);

	useEffect(() => {
		setStyleContents({
			backgroundImage: `url('${props.el.imageUrl}')`,
		});
	}, [props]);

	useEffect(() => {
		const imgDom = document.createElement("img");
		imgDom.src = props.el.imageUrl;
		imgDom.onload = () => {
			setActive(true);
		};
		imgDom.remove();
	}, [props.el.imageUrl]);

	return (
		<li
			className="ListPortfolio slideList"
			onClick={() => {
				props.handleListClick(props.index);
			}}
		>
			<div className="contents">
				{/* hover dim */}
				<div className="dim-gradient"></div>

				{/* image thumbnail */}
				<div className={`image ${active ? "active" : ""}`} style={styleContents}></div>

				{/* list text */}
				<div className="wrap-text">
					<h5>{props.el.name}</h5>
					<p>{props.el.brand}</p>
				</div>
			</div>
		</li>
	);
};

export default ListPortfolio;
